import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, TextField, InputAdornment } from '@mui/material';
import Draggable from 'react-draggable';
import Paper from '@mui/material/Paper';
import API_URL from '../../../utils/API_URL';


// Draggable Paper component
const PaperComponent = (props) => {
  return (
    <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
};

const GraphDialog = ({ open, onClose, category, currentValue, onSaveSuccess }) => {
  const { group_code, project_code } = useParams();
  const [inputValue, setInputValue] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (open) {
      setInputValue(currentValue > 0 ? String(currentValue) : '');
    }
  }, [open, currentValue]);

  const handleSave = async () => {
    setIsLoading(true);
    try {
      await axios.post(`${API_URL}/simulation/setGraphStandard`, {
        group_code,
        project_code,
        category,
        value: inputValue,
      });
      alert('기준값이 저장되었습니다.');
      onSaveSuccess(); // This will trigger fetchData in the parent
      onClose();
    } catch (err) {
      alert('기준값 저장에 실패했습니다.');
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (event) => {
    const { value } = event.target;
    // 숫자(소수점 포함) 및 빈 문자열만 허용하는 정규식
    if (value === '' || /^\d*\.?\d*$/.test(value)) {
      setInputValue(value);
    }
  };

  const getTitle = () => {
    switch (category) {
      case 'mch_utilization':
        return '장비 가동실적 기준값 설정';
      case 'uph':
        return '시간별 UPH 기준값 설정';
      default:
        return '그래프 기준값 설정';
    }
  };
  
  const getUnit = () => {
    return category === 'mch_utilization' ? '%' : 'ea';
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperComponent={PaperComponent}
      hideBackdrop={true}
      sx={{
        '& .MuiDialog-paper': {
          width: '400px',
          overflow: 'visible',
          backgroundColor: 'rgba(47, 51, 73, 0.8)',
          border: 'solid 2px rgb(63 68 99)',
          color: '#fff'
        }
      }}
    >
      <DialogTitle
        id="draggable-dialog-title"
        sx={{
          borderBottom: 'solid 1px #464646',
          cursor: 'move',
        }}
      >
        <Typography variant="h6" sx={{ color: '#ced4da' }}>
          {getTitle()}
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ padding: '1.5rem !important', mt: 2 }}>
        <TextField
          autoFocus
          margin="dense"
          label="기준값"
          type="text"
          inputMode="decimal"
          fullWidth
          variant="outlined"
          value={inputValue}
          onChange={handleInputChange}
          placeholder="기준선을 표시하지 않으려면 비워두세요."
          slotProps={{
            input: {
              endAdornment: <InputAdornment position="end" style={{color: '#fff'}}><span>{getUnit()}</span></InputAdornment>,
              sx: { color: '#fff' }
            },
            inputLabel: {
              sx: { color: '#999' }
            }
          }}
          sx={{
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: '#999',
              },
              '&:hover fieldset': {
                borderColor: '#fff',
              },
            },
          }}
        />
      </DialogContent>
      <DialogActions sx={{ borderTop: 'solid 1px #464646', padding: '1rem' }}>
        <Button onClick={handleSave} color="primary" variant="contained" disabled={isLoading}>
          {isLoading ? '저장 중...' : '저장'}
        </Button>
        <Button onClick={onClose} color="secondary">
          닫기
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default GraphDialog;